import packageJson from "../../../../package.json";

export default function VersionLogger() {
  console.log(`Current version: ${packageJson.version}`);
  return null;
}
